// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

import { activeSkin } from './skin';

/** The chrome choices of the active skin. Values live in theme/skins/<name>.ts. */
export const appChrome = activeSkin.chrome;

/**
 * True where the hole score input must build its own controls rather than lean on the painted
 * plank, peg and animal artwork. Read once at module load, like every other skin token, so a
 * style sheet may branch on it.
 */
export const drawnScoreInput = appChrome.scoreInput === 'drawn';

export default appChrome;
